import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material';
import HttpService from '../../hooks/Https-services';
import PAGE_ROUTES, { API_ROUTES } from '../../utils/constant';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function StaffingDashboardCards() {
  const [activeUserData, setActiveUserData] = useState<any>([]);
  const [idleUserData, setIdleUserData] = useState<any>([]);
  const navigate = useNavigate();

  const getStatus = useCallback(async () => {
    try {
      const activeUser = await HttpService.get(API_ROUTES.activeUserCounts);
      const idleUser = await HttpService.get(API_ROUTES.idleUserCounts);
      setActiveUserData(activeUser.data.data);
      setIdleUserData(idleUser.data.data);
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    getStatus();
  }, []);

  const handleCardClick = (status: string, key: any, ids: any) => {
    const idsString = ids.join(',');
    const query = { ids: idsString };
    // Navigate to the games page and pass the status as state and params
    navigate(
      {
        pathname: PAGE_ROUTES.USERS,
        search: new URLSearchParams(query).toString(),
      },
      { state: { status, key } }
    );
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={12}>
        <Table sx={{ width: '100%', borderCollapse: 'collapse' }}>
          <TableBody>
            {/* Row 1: Active Row */}
            <TableRow>
              <TableCell sx={{ border: 'none', verticalAlign: 'top' }}>
                <Typography variant="h6" fontWeight={600}>
                  ACTIVE
                </Typography>
              </TableCell>
              <TableCell sx={{ border: 'none', padding: 0 }}>
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
                  {/* Moderator Card */}
                  <Card
                    onClick={() =>
                      handleCardClick(
                        'moderator',
                        2,
                        activeUserData?.moderatorIds
                      )
                    }
                    style={{ cursor: 'pointer' }}
                    sx={{
                      border: 'solid black 2px',
                      borderRadius: 2,
                      height: '80px',
                      width: '130px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <CardContent
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <Typography variant="h6" fontWeight={600}>
                        {activeUserData?.moderatorCount}
                      </Typography>
                      <Typography fontWeight={600}>MODERATOR</Typography>
                    </CardContent>
                  </Card>
                  {/* Admin Card */}
                  <Card
                    onClick={() =>
                      handleCardClick('tagger', 3, activeUserData?.taggerIds)
                    }
                    style={{ cursor: 'pointer' }}
                    sx={{
                      border: 'solid black 2px',
                      borderRadius: 2,
                      height: '80px',
                      width: '130px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <CardContent
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <Typography variant="h6" fontWeight={600}>
                        {activeUserData?.taggerCount}
                      </Typography>
                      <Typography fontWeight={600}>TAGGER</Typography>
                    </CardContent>
                  </Card>
                </Box>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ border: 'none' }}></TableCell>
            </TableRow>
            {/* Row 2: Idle Row */}
            <TableRow>
              <TableCell sx={{ border: 'none', verticalAlign: 'top' }}>
                <Typography variant="h6" fontWeight={600}>
                  IDLE
                </Typography>
              </TableCell>
              <TableCell sx={{ border: 'none', padding: 0 }}>
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
                  {/* Moderator Card */}
                  <Card
                    onClick={() =>
                      handleCardClick(
                        'moderator',
                        2,
                        idleUserData?.moderatorIds
                      )
                    }
                    style={{ cursor: 'pointer' }}
                    sx={{
                      border: 'solid black 2px',
                      borderRadius: 2,
                      height: '80px',
                      width: '130px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <CardContent
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <Typography variant="h6" fontWeight={600}>
                        {idleUserData.moderatorCount}
                      </Typography>
                      <Typography fontWeight={600}>MODERATOR</Typography>
                    </CardContent>
                  </Card>
                  {/* Admin Card */}
                  <Card
                    onClick={() =>
                      handleCardClick('tagger', 3, idleUserData?.taggerIds)
                    }
                    style={{ cursor: 'pointer' }}
                    sx={{
                      border: 'solid black 2px',
                      borderRadius: 2,
                      height: '80px',
                      width: '130px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <CardContent
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <Typography variant="h6" fontWeight={600}>
                        {idleUserData?.taggerCount}
                      </Typography>
                      <Typography fontWeight={600}>TAGGER</Typography>
                    </CardContent>
                  </Card>
                </Box>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Grid>
    </Grid>
  );
}
